import { useTranslation } from 'react-i18next';
import EquipmentInvoiceCreateForm from '../form/EquipmentInvoiceCreateForm';
import { EnhancedDialog } from 'components/enhanced';

const TRANSLATION_PREFIX = 'pages.equipment-invoices.list';

interface EquipmentInvoiceCreateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}

export const EquipmentInvoiceCreateDialog = ({
  isOpen,
  onClose,
  onSubmit
}: EquipmentInvoiceCreateDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      open={isOpen}
      onClose={onClose}
      title={t(`${TRANSLATION_PREFIX}.add-dialog`)}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="md"
      submitButtonProps={{
        type: 'submit',
        form: 'newInvoice'
      }}>
      <EquipmentInvoiceCreateForm onSubmit={onSubmit} />
    </EnhancedDialog>
  );
};

export default EquipmentInvoiceCreateDialog;
